import { CONFERENCE_FAILED, CONFERENCE_LEFT } from '../base/conference/actionTypes';
import { PARTICIPANT_LEFT } from '../base/participants/actionTypes';
import { getVirtualScreenshareParticipantOwnerId } from '../base/participants/functions';
import { ReducerRegistry } from '../base/redux';

import {
    LOCAL_VIDEO_ZOOM_CHANGED,
    REMOTE_VIDEO_ZOOM_CHANGED,
    REQUEST_VIEW_ZOOM,
    SET_LOCAL_ZOOM_SHARE_APPROVED,
    SET_MODERATOR_ZOOM_SHARE_APPROVED
} from './actionTypes';

const STORE_NAME = 'features/zoom-sync';

const DEFAULT_STATE = {
    /**
     * View zoom the local participant applied to their own videos, keyed by
     * video type ('camera' / 'desktop').
     */
    local: {},

    /**
     * View zoom remote participants applied to their own videos, keyed by
     * participant id, then video type.
     */
    remote: {},

    /**
     * Pending request from the zoom level button for the large video.
     */
    requestedViewZoom: undefined,

    /**
     * Whether the local user approved sharing their zoomed local track with all participants.
     * undefined = not yet asked; true = approved; false = declined.
     */
    localZoomShareApproved: undefined,

    /**
     * Whether a moderator approved sharing a zoomed view of a pinned participant with all participants.
     * undefined = not yet asked; true = approved; false = declined.
     */
    moderatorZoomShareApproved: undefined
};

ReducerRegistry.register(STORE_NAME, (state = DEFAULT_STATE, action) => {
    switch (action.type) {
    case CONFERENCE_FAILED:
    case CONFERENCE_LEFT:
        return DEFAULT_STATE;

    case SET_LOCAL_ZOOM_SHARE_APPROVED:
        return {
            ...state,
            localZoomShareApproved: action.approved
        };

    case SET_MODERATOR_ZOOM_SHARE_APPROVED:
        return {
            ...state,
            moderatorZoomShareApproved: action.approved
        };

    case LOCAL_VIDEO_ZOOM_CHANGED:
        return {
            ...state,
            local: {
                ...state.local,
                [action.videoType]: action.zoomState
            }
        };

    case REMOTE_VIDEO_ZOOM_CHANGED:
        return {
            ...state,
            remote: {
                ...state.remote,
                [action.participantId]: {
                    ...state.remote[action.participantId],
                    [action.videoType]: action.zoomState
                }
            }
        };

    case REQUEST_VIEW_ZOOM:
        return {
            ...state,
            requestedViewZoom: {
                zoom: action.zoom,
                nonce: action.nonce
            }
        };

    case PARTICIPANT_LEFT: {
        const { id } = action.participant || {};
        const ownerId = getVirtualScreenshareParticipantOwnerId(id);

        if (ownerId && ownerId !== id) {
            // A virtual screenshare participant left: that share is over.
            if (!state.remote[ownerId]?.desktop) {
                return state;
            }

            const rest = { ...state.remote[ownerId] };

            delete rest.desktop;

            return {
                ...state,
                remote: {
                    ...state.remote,
                    [ownerId]: rest
                }
            };
        }

        if (!state.remote[id]) {
            return state;
        }

        const remote = { ...state.remote };

        delete remote[id];

        return {
            ...state,
            remote
        };
    }

    default:
        return state;
    }
});
